import { Routes } from '@angular/router';
import { ExtendSearchGuard } from '@ui/tenant-pool/mail-landing/util';

export const mailLandingUnauthenticatedRoutes: Routes = [
  {
    path: 'extend-search-until',
    canActivate: [ExtendSearchGuard],
    children: []
  },
  {
    path: 'extendSearchUntil',
    redirectTo: 'extend-search-until'
  },
  {
    path: 'auth/email-verification',
    loadComponent: () =>
      import('./verify-email/verify-email.component').then(
        m => m.VerifyEmailComponent
      )
  },
  {
    path: 'auth/confirm-new-email',
    loadComponent: () =>
      import('./confirm-email/confirm-email.component').then(
        m => m.ConfirmEmailComponent
      )
  },
  {
    path: 'auth/unlock',
    loadComponent: () =>
      import('./unlock-account/unlock-account.component').then(
        m => m.UnlockAccountComponent
      )
  },
  {
    path: 'auth/impersonate',
    loadComponent: () =>
      import('./impersonate/impersonate.component').then(
        m => m.ImpersonateComponent
      )
  }
];

export const mailLandingAuthenticatedRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./logout/logout.component').then(m => m.LogoutComponent)
  }
];

export const nowStripeCheckoutRoutes: Routes = [
  {
    path: 'result',
    title: 'immomio_now.subscription.checkout_step_title_l',
    loadComponent: () =>
      import('./now-stripe-checkout-result/now-stripe-checkout-result.component').then(
        m => m.NowStripeCheckoutResultComponent
      )
  }
];
